module.exports = __webpack_public_path__ + "static/img/Architecture_元生_image@2x.88c21635.jpg";